import * as React from 'react'
import { connect } from 'react-redux'

import { Entity } from '../app/entity'
import Navigator from '../app/navigator'
import store from '../app/store'

import LegacyNavigatorWrapper from '../helper/legacyNavigatorWrapper'
import { WithEnvironmentAndService } from '../helper/WithEnvironmentAndService'
import { ApplicationState } from '../redux/ApplicationState'

import { IssueType, nameForErrorLevelMultiple } from '../domain/Error'
import OnlineDropdownSelector from '../filter/onlineDropdownSelector'
import BoxBody from '../helper/boxBody'
import Loading from '../helper/loading'
import { Alert } from '../ui/alert'
import { AlertTitle } from '../ui/alertTitle'
import { Box, BoxHeader, BoxTitle } from '../ui/box'
import ErrorItem from './ErrorListItem'
import Pager from './list/pager'
import StatusSelector from './list/statusSelector'
import { ObservationListItem } from './ObservationListItem'
import Selector from '../filter/selector'
import Link from '../helper/link'
import { TidewaysContext } from '../app/context'
import moment from 'moment'

interface Props {
    navigator: any
    parameters: any
    loading?: boolean
    data?: any
    tidewaysContext: TidewaysContext
    level: IssueType
    start?: Date
    end?: Date
}

class ErrorList extends React.Component<Props> {
    public static defaultProps = {
        loading: false,
        data: null,
    }

    public resolveAll = href => {
        const result = this.confirmModalText()
        if (result) {
            jQuery.ajax({
                url: href,
                success: data => {
                    store.dispatch({ type: 'Errors.purge' })
                    // we need to force a reload, otherwise no new ajax call is made.
                    const parameters = {
                        ...this.props.parameters,
                        error: undefined,
                    }

                    parameters.reload = +(parameters.reload || 0) + 1
                    this.props.navigator.replace(parameters)
                },
            })
        }
    }

    public getNavigator = () => {
        return new LegacyNavigatorWrapper(this.props.navigator)
    }
    private nonFatalLevels: Array<{ level: string; label: string }> = [
        { level: '', label: 'All' },
        { level: 'deprecated', label: 'Deprecations' },
        { level: 'warning', label: 'Warnings' },
        { level: 'notice', label: 'Notices' },
    ]

    public render() {
        if (this.props.level === 'observation' && this.props.parameters.s === '__all') {
            return (
                <Box>
                    <BoxBody style={{ marginTop: 10 }}>
                        <Alert level="info">
                            <AlertTitle>Not Supported Yet</AlertTitle>
                            <p>The Observation feature does not support displaying data for &apos;all&apos; services right now.</p>
                        </Alert>
                    </BoxBody>
                </Box>
            )
        }

        if (!this.props.data) {
            return <Loading {...this.props} height={100} title="Recent Errors" />
        }

        const errors = this.props.data.errors.errors
        const { level } = this.props

        const noTransactionFilter =
            level === IssueType.DEPRECATED ||
            level === IssueType.INCIDENT ||
            level === IssueType.NON_FATALS ||
            level === IssueType.OBSERVATION
        const levelIsObservation = level === IssueType.OBSERVATION
        const levelisRelease = level === IssueType.RELEASE

        return (
            <WithEnvironmentAndService
                render={({ service, environment, setService, setEnvironment }) => (
                    <Box>
                        {levelisRelease || (levelIsObservation && !this.props.tidewaysContext.application.license.bottleneckBeta) ? null : (
                            <BoxHeader>
                                {this.props.tidewaysContext.organization.features.includes('beta') ? (
                                    <div>
                                        <BoxTitle>Recent {nameForErrorLevelMultiple(level)}</BoxTitle>
                                        {this.props.start && this.props.end ? (
                                            <div className="pull-right" style={{ marginTop: 10, marginRight: 8, marginBottom: -2 }}>
                                                <button className="btn btn-default" onClick={() => {}} style={{ pointerEvents: 'none' }}>
                                                    {moment(this.props.start).format('DD.MM')} - {moment(this.props.end).format('DD.MM')}
                                                </button>
                                                <Link
                                                    route={`XhprofErrorBundle.Issues.${level == IssueType.ERROR ? 'errors' : 'incident'}`}
                                                    params={{
                                                        page: 1,
                                                        weekStartDate: undefined,
                                                        s: service,
                                                        env: environment,
                                                    }}
                                                >
                                                    <button className="btn btn-default">
                                                        <i className="fa fa-times-circle" />
                                                    </button>
                                                </Link>
                                            </div>
                                        ) : null}
                                    </div>
                                ) : null}
                                <ul className="nav navbar-nav tw-m-8" style={{ float: 'none' }}>
                                    <li>
                                        <StatusSelector
                                            level={level}
                                            selectedStatus={this.props.data.criteria.status}
                                            navigator={this.getNavigator()}
                                        />
                                    </li>
                                    {level === IssueType.NON_FATALS ? (
                                        <li className="tw-ml-8">
                                            <Selector
                                                type="non_fatal_type"
                                                head={this.nonFatalLevelHead(this.props.data.criteria.nonFatalType)}
                                            >
                                                <ul className="dropdown-menu" role="menu">
                                                    {this.nonFatalLevels.map(({ level, label }) => (
                                                        <li key={level + 'key'}>
                                                            <Link params={{ non_fatal_type: level }} keepAllUnspecifiedParams>
                                                                {label}
                                                            </Link>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </Selector>
                                        </li>
                                    ) : null}

                                    {noTransactionFilter ? null : (
                                        <li style={{ marginLeft: 6 }}>
                                            <OnlineDropdownSelector
                                                type="transaction"
                                                queryKey="transactionIds"
                                                selected={this.props.data.criteria.transactionIds}
                                                navigator={this.getNavigator()}
                                                searchUrl={this.props.navigator.path(
                                                    'XhprofProfilerBundle.Transaction.dropdownSearchSelect',
                                                    {
                                                        s: this.props.tidewaysContext.service,
                                                        env: this.props.tidewaysContext.environment,
                                                    },
                                                )}
                                                openRight
                                            />
                                        </li>
                                    )}
                                    {levelIsObservation ? null : (
                                        <li className={'pull-right'}>
                                            <button
                                                key="ResolveAll"
                                                onClick={() =>
                                                    this.resolveAll(
                                                        this.props.navigator.path('XhprofErrorBundle.Issues.resolveAll', {
                                                            ...this.props.parameters,
                                                            level: this.props.data.criteria.level,
                                                        }),
                                                    )
                                                }
                                                className="btn btn-default"
                                                title="Mark all issues as resolved across the selected environment and service"
                                                disabled={this.props.loading}
                                            >
                                                Resolve All
                                            </button>
                                        </li>
                                    )}
                                </ul>
                            </BoxHeader>
                        )}

                        {level === IssueType.SLOWSQL ? (
                            <BoxBody {...this.props} className="no-padding">
                                <div className="alert alert-info">
                                    <p>
                                        Shows queries slower than 1000ms (default).{' '}
                                        <a
                                            target="_blank"
                                            href={
                                                'https://support.tideways.com/documentation/setup/configuration/slow-sql-logging.html?utm_medium=app&utm_source=error-list&utm_campaign=slow-sql-logging'
                                            }
                                            rel="noreferrer"
                                        >
                                            Documentation
                                        </a>
                                    </p>
                                </div>
                            </BoxBody>
                        ) : null}

                        <BoxBody {...this.props} className="no-padding">
                            {errors.map(error =>
                                error.level === IssueType.OBSERVATION ? (
                                    <ObservationListItem
                                        key={error.id}
                                        observation={error}
                                        currentPage={this.props.data.errors.currentPage}
                                        active={error.id === this.props.parameters.error}
                                    />
                                ) : (
                                    <ErrorItem key={error.id} error={error} currentPage={this.props.data.errors.currentPage} />
                                ),
                            )}
                            {!errors.length && (
                                <div>
                                    <p className="lead text-center">No entries! Good work!</p>
                                </div>
                            )}
                        </BoxBody>

                        {this.props.data.errors.totalPages > 1 ? (
                            <div className="box-footer text-center">
                                <Pager
                                    totalPages={this.props.data.errors.totalPages}
                                    currentPage={this.props.data.errors.currentPage}
                                    navigator={this.getNavigator()}
                                />
                            </div>
                        ) : null}
                    </Box>
                )}
            />
        )
    }
    private confirmModalText(): boolean {
        if (this.props.tidewaysContext.service === '__all') {
            return confirm(
                'Do you really want to resolve all errors from the environment "' +
                    this.props.tidewaysContext.selectedEnvironment.name +
                    (this.props.parameters.transactionIds
                        ? '", all services and selected transaction' + (this.props.parameters.transactionIds.length > 1 ? 's' : '') + '?'
                        : '" and all services?'),
            )
        }
        return confirm(
            'Do you really want to resolve all errors from the environment "' +
                this.props.tidewaysContext.selectedEnvironment.name +
                (this.props.parameters.transactionIds
                    ? '", the service "' +
                      this.props.tidewaysContext.service +
                      '" and selected transaction' +
                      (this.props.parameters.transactionIds.length > 1 ? 's' : '') +
                      '?'
                    : '" and the service "' + this.props.tidewaysContext.service + '"?'),
        )
    }

    private nonFatalLevelHead = (nonFatalType: '' | 'warning' | 'notice' | 'deprecated'): string => {
        switch (nonFatalType) {
            case 'warning':
                return 'Warnings Only'
            case 'notice':
                return 'Notices Only'
            case 'deprecated':
                return 'Deprecations Only'
            default:
                return 'All Error Levels'
        }
    }
}

export default connect((globalState: ApplicationState) => {
    const list = globalState.errors.list || new Entity()
    return {
        tidewaysContext: globalState.tidewaysContext,
        navigator: new Navigator(globalState.tidewaysContext.route, globalState.tidewaysContext.router),
        parameters: globalState.tidewaysContext.route.parameters,
        data: list.data,
    }
})(ErrorList)
